// extracted by mini-css-extract-plugin
export default {"root":"AddToCartBtn_root__csiC+","cartBtn":"AddToCartBtn_cartBtn__X5YXz","cartBtnSuccess":"AddToCartBtn_cartBtnSuccess__smJE6","error":"AddToCartBtn_error__tuYgy"};